// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamProfileGetBody = {
  teamId: string;
};

export type typeTeamProfileGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teamId: string;
    name: string;
    marketName: string;
    nickname: string;
    abbreviation: string;
    primaryColorHex?: string | null;
    secondaryColorHex?: string | null;
    leagueId: string;
    leagueKey: string;
    leagueName: string;
    leagueSeasonId?: string | null;
    recordLabel?: string | null;
    standingLabel?: string | null;
    tabs: string[];
    logoUrl?: string | null;
  };
};

export type typeTeamProfileGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamProfileGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamProfileGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamProfileGetBody = {
  type: "object",
  properties: { teamId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamProfileGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamProfileGetBody);
  }

  return async function postTeamProfileGet(
    payload: typeTeamProfileGetBody,
  ): Promise<typeTeamProfileGetOutput200 | typeTeamProfileGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamProfileGet" failed before calling the network. #894309fc5cea`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#894309fc5cea" },
        },
        data: null,
      } as typeTeamProfileGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team/profile-get`,
      httpMethod: "POST",
      options,
    })) as typeTeamProfileGetOutput200 | typeTeamProfileGetOutput400;
  };
}
